import { useState } from "react";
import XlsxMapper from "../../../../../components/XlsxMapper/XlsxMapper";
import { getFormattedXLSXData } from "../../../../../services/lib/xlsxService";
import { ManageMultipleDeclarationsStore } from "../ManageMultipleDeclarations";
import dayjs from "dayjs";
import advService from "../../../../../util/advService";
import { POST_EXCEL_FILE_MAPPING } from "../../../../../util/newconfig";

type Props = {
    store: ManageMultipleDeclarationsStore;
    setStore: React.Dispatch<
        React.SetStateAction<ManageMultipleDeclarationsStore>
    >;
};

const ManageMultipleDeclarationsStep2 = (props: Props) => {
    // return <></>
    return (
        <div>
            {props.store.data.length > 0 && (
                <XlsxMapper
                    data={props.store.data}
                    required={[
                        {
                            key: "declarationDate",
                            label: "Declaration Date",
                            type: "date",
                            mandatory: true,
                        },
                        {
                            key: "goodsValue",
                            label: "Goods Value",
                            type: "number",
                            mandatory: true,
                        },
                        {
                            key: "remark",
                            label: "Remark",
                            type: "string",
                            mandatory: true,
                        },
                        {
                            key: "receiverName",
                            label: "Receiver Name",
                            type: "string",
                            mandatory: false,
                        },
                        {
                            key: "receiverAddress",
                            label: "Receiver Address",
                            type: "string",
                            mandatory: false,
                        },
                        {
                            key: "consignmentDetails",
                            label: "Consignment Details",
                            type: "string",
                            mandatory: false,
                        },
                        {
                            key: "senderName",
                            label: "Sender Name",
                            type: "string",
                            mandatory: false,
                        },
                        {
                            key: "invoiceNumber",
                            label: "Invoice Number",
                            type: "string",
                            mandatory: false,
                        },
                        {
                            key: "invoiceDate",
                            label: "Invoice Date",
                            type: "date",
                            mandatory: false,
                        },
                        {
                            key: "transportationMode",
                            label: "Transportation Mode",
                            type: "string",
                            mandatory: false,
                        },
                        {
                            key: "transportationNumber",
                            label: "Transportation Number",
                            type: "string",
                            mandatory: false,
                        },
                        // {
                        //     key: "active",
                        //     label: "Active",
                        //     type: "string", // Since XlsxMapper likely can't handle boolean inputs directly
                        //     mandatory: false,
                        // },
                    ]}
                    defaultMapping={props.store.selectedMappingMapping}
                    defaultDateMapping={props.store.selectedMappingDateMapping}
                    submitMapping={(mapping, dateMapping) => {
                       debugger

                        let mappedData = props.store.data.map((item) => {
                            let mappedItem: Record<string, string> = {};
                            for (const key in mapping) {
                                if (mapping[key] !== "") {
                                    if (
                                        dateMapping &&
                                        dateMapping[key] &&
                                        dateMapping[key] !== ""
                                    ) {
                                        // check if the date is in the correct format
                                        debugger
                                        if (
                                            dayjs(
                                                item[mapping[key]].trim(),
                                                dateMapping[key].toUpperCase().split("-").join("/")
                                                , true
                                            ).isValid()
                                        ) { 
                                            let  a = 
                                            mappedItem[key] = dayjs(
                                                item[mapping[key]].trim(),
                                                dateMapping[key]
                                            ).format("YYYY-MM-DD")
                                            debugger
                                            mappedItem[key] = dayjs(
                                                item[mapping[key]].trim(),
                                                dateMapping[key].toUpperCase().split("-").join("/")
                                            ).format("YYYY-MM-DD");
                                        } else {
                                            mappedItem[key] = "Invalid Date";
                                        }

                                        
                                        
                                    }
                                    // If the mapping is not a date, just assign the value directly
                                    else {
                                        mappedItem[key] = item[mapping[key]];
                                    }
                                }
                            }
                            return mappedItem;
                        });
                        props.setStore((prev) => ({
                            ...prev,
                            mappedData: mappedData,
                            selectedMappingMapping: mapping,
                            selectedMappingDateMapping: dateMapping,
                            step: 3,
                        }));
                    }}
                    back={() => {
                        props.setStore((prev) => ({
                            ...prev,
                            step: 1,
                        }));
                    }}
                    noStyle={true}
                />
            )}
        </div>
    );
};
export default ManageMultipleDeclarationsStep2;
